import React, { useState, useEffect } from 'react';
import { Alert, Col, Row, ToggleButton } from 'react-bootstrap';
import '../../../styles/RegDashboard.css';
import { HHIEButton } from '../../utility/HHIEButton';
import { DSAModal } from './Modals/DSAModal';
import { ContentBox } from './utility/ContentBox';
import { ContentItem } from './utility/ContentItem';
import { ContentTitle } from './utility/ContentTitle';

export function AccountInfo(props) {
    const [showDsaModal, setShowDsaModal] = useState(false);
    const [account, setAccount] = useState(props.account);
    const [user, setUser] = useState(props.user);
    const [ignoreLimitCheck, setIgnoreLimitCheck] = useState(false);
    const [loadingCanChangeDSA, setLoadingCanChangeDSA] = useState(true);
    const [canChangeDSA, setCanChangeDSA] = useState(true);
    const [loadingCanEditAccount, setLoadingCanEditAccount] = useState(true);
    const [canEditAccount, setCanEditAccount] = useState(true);
    const [userIsAdmin, setUserIsAdmin] = useState(false);
    useEffect(() => {
        if (props.account !== null) {
            setIgnoreLimitCheck(account.ignorePOCLimit)
            setAccount(props.account);
            setUser(props.user);
            setUserIsAdmin(props.userIsAdmin)
            setLoadingCanChangeDSA(true);
            setLoadingCanEditAccount(true);
            setCanChangeDSA(true);
            setCanEditAccount(true);
        }
    }, [props]);

    useEffect(() => {
        Promise.resolve(AlreadyRequestedDSAChange());
        Promise.resolve(AlreadyModifiedAccount());
        props.modifyAccount(account);
    }, [account]);

    const currentServices = () => {
        var services = "";

        if (account.registrationType && account.registrationType !== "") services = account.registrationType;
        else {
            if (account.chr) services += "CHR;";
            if (account.dsm) services += "DSM;";
            if (account.referrals) services += "Referrals;";
            if (account.notify) services += "Notify;";
            if (services.length > 0) {
                services = services.slice(0, -1);
            }
        }
        return services;
    }

    const submitIgnorePOCLimit = (checked) => {
        account.ignorePOCLimit = checked;
        props.modifyAccount(account)

        fetch('api/registration/setIgnoreLimit/' + account.id + '/' + checked)
            .then((response) => {
                response.json()
                    .then((json) => {
                        if (json.errors !== null && json.errors !== "") alert(json.errors)
                        console.log(json.message);
                    })
                    .catch((error) => {
                        console.log("retrieved Account error: " + error);
                    })
            })
            .catch((error) => {
                console.log("Error getting a response: " + error);
            });
    }

    const AlreadyRequestedDSAChange = async () => {
        var accountId = account.id;
        const HasRequested =
            await fetch('api/registration/check-dsa-change-requested/' + accountId)
                .then(async (dsaResponse) => {
                    try {
                        setLoadingCanChangeDSA(false);
                        return await dsaResponse.json()
                            .then(json => {
                                if (json.errors !== null && json.errors !== "") alert(json.errors)
                            return json.message
                        });
                    }
                    catch (ex) {
                        return console.log(ex);
                    }
                })
                .catch((error) => {
                    console.log("Error getting a response: " + error);
                });
        setCanChangeDSA(!HasRequested);
    }

    const AlreadyModifiedAccount = async () => {
        var accountId = account.id;
        const HasRequested =
            await fetch('api/registration/check-account-modified/' + accountId)
                .then(async (accountChangedResponse) => {
                    try {
                        setLoadingCanEditAccount(false);
                        return await accountChangedResponse.json()
                            .then(json => {
                                if (json.errors !== null && json.errors !== "") alert(json.errors)
                                return json.message
                            });
                    }
                    catch (ex) {
                        return console.log(ex);
                    }
                })
                .catch((error) => {
                    console.log("Error getting a response: " + error);
                });
        setCanEditAccount(!HasRequested);
    }

    const DSAChangeSection = (text) => {
        var buttonTitle = "";
        if (text === "Assign") {
            buttonTitle = "Assign Member as DSA"
        } else {
            buttonTitle = "Request DSA Change"
        }
        return (
            <>
                {canChangeDSA ?
                    <HHIEButton
                        disabled={loadingCanChangeDSA}
                        id="change-dsa"
                        variant="primary"
                        size="sm"
                        onClick={() => { setShowDsaModal(true) }}
                        title={buttonTitle}
                    />
                    : <Alert
                        variant="warning" id="change-dsa-alert">The HHIE are processing a request to change the Designated Signing Authority.</Alert>
                }
            </>
        )
    }
    return (
        <ContentBox>
            {account &&
            <>
                <Row>
                    <ContentTitle
                        position="left"
                        title="Account Details"
                    />
                </Row>
                <Row>
                    <ContentItem 
                        position="left"
                        label="Organization Name"
                        content={
                            <>
                            {account.legalName}<br />
                            {account.departmentName ?? ""}
                            </>}
                    />
                </Row>
                <hr/>
                <Row>
                {(currentServices().includes("Notify") && account.designatedNotifyContact) ?
                    <ContentItem 
                        position="left"
                        label="Primary Notify POC" 
                        content={<div id="notify-poc">{account.designatedNotifyContact.firstName} {account.designatedNotifyContact.middleName} {account.designatedNotifyContact.lastName}  {account.designatedNotifyContact.email ? "(" + account.designatedNotifyContact.email + ")" : ""}</div>}
                    />
                    :
                    <Col></Col>
                }
                {(currentServices().includes("CHR") && account.designatedChrContact) &&
                    <ContentItem 
                        position="right"
                        label="Primary CHR POC"
                        content={<div id="chr-poc">{account.designatedChrContact.firstName} {account.designatedChrContact.middleName} {account.designatedChrContact.lastName} {account.designatedChrContact.email ? "(" + account.designatedChrContact.email + ")" : ""}</div>}
                    />
                }
                </Row>
                <Row>
                {account.npi ?
                    <ContentItem 
                        position="left"
                        label="Business NPI" 
                        content={<div id="account-npi">{account.npi}</div>} 
                    />
                    :
                    <Col></Col>
                }
                
                {account.designatedSigningAuthority ?
                    <ContentItem 
                        position="right"
                        label="Designated Signing Authority Email" 
                        content={<div id="dsa">{account.designatedSigningAuthority.email} ({account.designatedSigningAuthority.firstName} {account.designatedSigningAuthority.middleName} {account.designatedSigningAuthority.lastName}) {DSAChangeSection("Request")}</div>}
                    />
                    :
                    <ContentItem 
                        position="right"
                        label="Designated Signing Authority Email" 
                        content={
                            DSAChangeSection("Assign")
                        }
                    />
                }
                </Row>

                <Row>
                {(account.shippingAddress.street && account.shippingAddress.street !== "") ?
                <ContentItem
                    position="left"
                    label="Shipping Address"
                    content={
                        <div id="account-shipping">
                            {account.shippingAddress.street}, {account.shippingAddress.city}, {account.shippingAddress.state} {account.shippingAddress.zipCode}
                        </div>
                    }
                />
                : <Col></Col>
                }
                {(account.location.street && account.location.street !== "") &&
                <ContentItem
                    position="right"
                    label="Billing Address"
                    content={
                        <div id="account-billing">
                            {account.location.street}, {account.location.city}, {account.location.state} {account.location.zipCode}
                        </div>
                    }
                />
                }
                </Row>
                <Row>
                    <ContentItem
                        position="left"
                        label="Office Phone Number"
                        content={
                            <div id="account-phone">{account.phone}</div>
                        }
                    />
                </Row>
                <Row>
                    {userIsAdmin && <ContentItem
                        position="left"
                        label="Ignore POC Limit"
                        content={
                            <ToggleButton
                                id="ignore-poc-limit"
                                style={{padding: '0px', margin: '0px'}}
                                variant="outline"
                                type="checkbox"
                                checked={ignoreLimitCheck}
                                onChange={
                                    (e) => { 
                                        setIgnoreLimitCheck(e.target.checked); 
                                        submitIgnorePOCLimit(e.target.checked) 
                                    }
                                }
                            >
                            </ToggleButton>
                        }/>
                    }
                    {canEditAccount ?
                    <Col className="d-flex justify-content-end">
                            <HHIEButton
                                disabled={loadingCanEditAccount}
                            id="acct-edit-btn"
                            variant="primary"
                            size="sm"
                            onClick={() => { window.location.href = '/account-form' }}
                            title="Edit"
                        />
                    </Col>
                    :
                    <ContentItem
                        position="right"
                        content={
                            <Alert 
                                id="edit-account-alert" 
                                variant="warning"
                                style={{
                                    borderRadius: "10px"
                                }}
                            >
                                Warning: you can't edit these account details. <hr/>The HHIE are processing the changes {account.legalName} has requested, and no additional changes can be facilitated until the pending request has been granted or denied by the HHIE.
                            </Alert>
                        }
                    />
                }
                </Row>
                {/* Leave here */}
                <DSAModal 
                    show={showDsaModal} 
                    setShow={
                        (value) => { 
                            setShowDsaModal(value) 
                        }
                    } 
                    members={props.account.members} 
                    user={props.user} 
                    account={props.account} 
                    setAccount={
                        (acct) => { 
                            setAccount(acct) 
                        }
                    } 
                    setCanChangeDSA={
                        (value) => { 
                            setCanChangeDSA(value) 
                        }
                    }
                />
            </>
            }
        </ContentBox>
    );
}
